import React from "react";
import AddLoyaltyRewards from "../../components/Loyalty/AddLoyaltyRewards";
import LoyaltyRewardsDisplay from "../../components/Loyalty/LoyaltyRewardsDisplay";

const LoyaltyRewards = () => {
	return (
		<>
			<LoyaltyRewardsDisplay />
			<AddLoyaltyRewards />
		</>
	);
};

export default LoyaltyRewards;
